var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01TdePosicionesSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.24 16.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.83,172.25h3.09a2.06,2.06,0,0,0,0-4.11h-3.09a2.06,2.06,0,1,0,0,4.11Zm0-3.09h3.09a1,1,0,0,1,0,2.07h-3.09a1,1,0,0,1,0-2.07Z",
    transform: "translate(-387.91 -168.14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M395.83,178.42H402a2.06,2.06,0,1,0,0-4.11h-6.17a2.06,2.06,0,1,0,0,4.11Zm0-3.08H402a1,1,0,0,1,0,2.06h-6.17a1,1,0,1,1,0-2.06Z",
    transform: "translate(-387.91 -168.14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.09,180.49h-9.26a2.06,2.06,0,1,0,0,4.11h9.26a2.06,2.06,0,1,0,0-4.11Zm0,3.08h-9.26a1,1,0,1,1,0-2.06h9.26a1,1,0,1,1,0,2.06Z",
    transform: "translate(-387.91 -168.14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390,168.14A2.06,2.06,0,1,0,392,170.2,2.05,2.05,0,0,0,390,168.14Zm0,3.09a1,1,0,1,1,1-1A1,1,0,0,1,390,171.23Z",
    transform: "translate(-387.91 -168.14)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390,174.31a2.06,2.06,0,1,0,2.06,2.06A2.06,2.06,0,0,0,390,174.31Zm0,3.09a1,1,0,1,1,1-1A1,1,0,0,1,390,177.4Z",
    transform: "translate(-387.91 -168.14)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390,180.49a2.06,2.06,0,1,0,2.06,2A2.05,2.05,0,0,0,390,180.49Zm0,3.08a1,1,0,1,1,1-1A1,1,0,0,1,390,183.57Z",
    transform: "translate(-387.91 -168.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01TdePosicionesSelect);
export default __webpack_public_path__ + "static/media/01_TdePosiciones_Select.343c3af84a7d0fe0519b8f8a9abf5387.svg";
export { ForwardRef as ReactComponent };